import { isInComponentsIframe } from '../../embedded';

export default {
  handler: isInComponentsIframe() ? 'openNewTab' : 'relativeUrl',
  data: ({ accountSection }) => ({
    ACCOUNTHISTORYOPENBETS: '/bv_cashier/history/3',
    ACCOUNTHISTORYSETTLEDBETS: '/bv_cashier/history/4',
    ACCOUNTHISTORYCASINO: '/bv_cashier/history/1',
    DEPOSIT: '/bv_cashier/deposit',
    ACCOUNTDETAILSSETTINGS: '/preferences/edit',
    FORGOTPASSWORD: '/account/password_reset',
    LOGIN: '/login',
    CREATEACCOUNT: '/account/new',
    REFERAFRIEND: '/refer_a_friend',
    SGPORTAL: '/safer_gambling/portal',
  }[accountSection] || '/bv_cashier/overview'),
};
